import axios from "axios";
import * as config from "../../config";
import UserProfile from '../../UserProfile';

// export function getSaleList() {
//     var authorization = config.headerCallAPI
//     var token = ''
//     if (UserProfile.getUserdata()) {
//         token = UserProfile.getUserdata().token
//     }
//     authorization.headers['Authorization'] = "Bearer " + token;
//     return axios.get(config.urlAPI + '/staff/get', authorization)
//         .then(res => {
//             return res
//         }).catch(err => {
//             return err.res
//         })
// }

export function getSaleList() {
    var authorization = config.headerCallAPI
    var token = ''
    if (UserProfile.getUserdata()) {
        token = UserProfile.getUserdata().token
    }
    authorization.headers['Authorization'] = "Bearer " + token;
    return axios.get(config.urlAPI + '/attendence/trackview', authorization)
        .then(res => {
            return res
        }).catch((error) => {
            // Error
            if (error.response) {
                // The request was made and the server responded with a status code
                // that falls out of the range of 2xx
                console.log(error.response.data);
                // console.log(error.response.status);
                // console.log(error.response.headers);
                return error.response.data.message
            } else if (error.request) {
                // The request was made but no response was received
                // `error.request` is an instance of XMLHttpRequest in the 
                // browser and an instance of
                // http.ClientRequest in node.js
                console.log(error.request);
            } else {
                // Something happened in setting up the request that triggered an Error
                console.log('Error', error.message);
            }
            console.log(error.config);
        });
}

export function getTrackview(data) {
    var authorization = config.headerCallAPI
    var token = ''
    if (UserProfile.getUserdata()) {
        token = UserProfile.getUserdata().token
    }
    authorization.headers['Authorization'] = "Bearer " + token;
    return axios.post(config.urlAPI + '/trackview', data, authorization)
        .then(res => {
            return res
        }).catch((error) => {
            // Error
            if (error.response) {
                // The request was made and the server responded with a status code
                // that falls out of the range of 2xx
                console.log(error.response.data);
                // console.log(error.response.status);
                // console.log(error.response.headers);
                return error.response.data.message
            } else if (error.request) {
                // The request was made but no response was received
                // `error.request` is an instance of XMLHttpRequest in the 
                // browser and an instance of
                // http.ClientRequest in node.js
                console.log(error.request);
            } else {
                // Something happened in setting up the request that triggered an Error
                console.log('Error', error.message);
            }
            console.log(error.config);
        });
}

